import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  avoidAnchorsAppendingHistory(event) {
    const anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;

    event.preventDefault();
    const targetId = anchor.getAttribute('href').substring(1);
    const targetEl = document.getElementById(targetId);
    if (targetEl) {
      targetEl.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
